import { ChevronRight } from "lucide-react"

interface ChatThinkingProps {
  /** Accumulated chain-of-thought text. */
  thinking: string
  /** True while the answer is still streaming; the panel auto-expands so the
   * reasoning is visible as it arrives, then collapses once the turn finalizes. */
  streaming?: boolean
}

/**
 * Collapsible chain-of-thought panel for an assistant message. Only rendered when
 * the backend streams reasoning (RAG_STREAM_THINKING on; dev/local only).
 */
export function ChatThinking({ thinking, streaming }: ChatThinkingProps) {
  return (
    <details
      open={streaming}
      className="group rounded-md border border-border/60 bg-background/40 text-sm text-muted-foreground"
    >
      <summary className="flex cursor-pointer select-none items-center gap-1 px-2 py-1 font-medium [&::-webkit-details-marker]:hidden">
        <ChevronRight className="h-3.5 w-3.5 transition-transform group-open:rotate-90" />
        {streaming ? "Thinking…" : "Thought process"}
      </summary>
      <div className="whitespace-pre-wrap px-2 pb-2 pt-0.5 font-mono text-xs leading-relaxed">
        {thinking}
      </div>
    </details>
  )
}
